import labNoService from "./labNoService";

const updateLabNoService = [
    ...labNoService
];

export { updateLabNoService as default, labNoService }